/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".go-up-img[_ngcontent-%COMP%]{width:33px}.back-to-top[_ngcontent-%COMP%]{font-size:15px;line-height:24px}.button-go-up-container[_ngcontent-%COMP%]{top:-70px;right:0;left:0}.translate[_ngcontent-%COMP%]{transition:all .3s ease-in-out}.translate[_ngcontent-%COMP%]:hover{transform:translateY(-2px)}"];
export { styles as styles };
